<template>
    <AuthLayout :imageSrc="sideImage" :fullImage="true" imageAlign="start">
        <div class="flex justify-content-center align-items-center w-full h-full">
            <div class="text-center">
                <h2 class="Paragraph-Medium mb-8">Choose your role to get started</h2>
                <div class="flex justify-content-center gap-4 mb-6 flex-wrap">
                    <div v-for="(plan, index) in plans" :key="index" class="card-wrapper">
                        <Card class="plan-card p-2" @click="submit(plan.url,plan.type)">
                            <template #header>
                                <div class="justify-content-center pt-2">
                                    <img :src="plan.image" :alt="plan.title" class="card-img" />
                                </div>
                            </template>
                            <template #title>
                                <div class="Caption py-2">{{ plan.title }}</div>
                            </template>
                        </Card>
                    </div>
                </div>
                <label for="username" class="Label pt-3">Already have an account? <span
                        class="Label-teal cursor-pointer" @click="Login">Login</span></label>
            </div>
        </div>
    </AuthLayout>
</template>

<script setup>
import AuthLayout from "@/layout/AuthLayout.vue";
import Card from 'primevue/card';
import { ref } from 'vue';
import { useRouter } from "vue-router";
import { useAuthStore } from "@/stores/authStore";
import sideImage from "@/assets/Images/onBoarding.png";

const authStore = useAuthStore();
const router = useRouter();
const plans = ref([
    { title: 'I’m a Student', image: require('@/assets/Images/Image Student.png'), url: '/studentOnBoarding',type: 'student' },
    { title: 'I’m a Tutor', image: require('@/assets/Images/Image Tutor.png'), url: '/tutorOnBoarding',type: 'tutor' },
    { title: 'We are an Institution', image: require('@/assets/Images/Image Institution.png'), url: '/institutionOnBoarding',type: 'institute' },
]);
const Login = async () => {
    router.push('/login');
}
const submit = async (url,type) => {
    authStore.setUserType(type);
    router.push(url);
}
</script>

<style scoped>
.card-wrapper {
    width: 170px;
    height: auto;
    max-width: 100%;
}

.plan-card {
    border: 1px solid lightgray;
    overflow: hidden;
    border-radius: 0px;
    cursor: pointer;
}

.plan-card:hover {
    border-color:none;
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
}

.card-img {
    height: 118px;
    width: 118px;
    object-fit: cover;
}


@media (max-width: 768px) {
    .card-wrapper {
        width: 100%;
        margin-bottom: 1rem;
    }
}
</style>
